import { useState, type FormEvent } from "react";
import { contact as contactApi } from "../services/auth";
import "../components/AuthForm.css";

export function ContactPage() {
  const [form, setForm] = useState({ name: "", email: "", company: "", message: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [sent, setSent] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null); setSubmitting(true);
    const res = await contactApi.submit({
      name: form.name,
      email: form.email,
      company: form.company || undefined,
      message: form.message,
    });
    setSubmitting(false);
    if (res.ok) { setSent(true); setForm({ name: "", email: "", company: "", message: "" }); }
    else setError(res.error.message);
  }

  return (
    <section className="section container">
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "var(--space-12)" }} className="contact-grid">
        <div className="contact-intro">
          <header className="page-hero page-hero--left" style={{ marginBottom: 0 }}>
            <p className="eyebrow">Contact us</p>
            <h1>Tell us about the problem you're working on.</h1>
            <p className="lede">
              We respond to every inquiry within one business day. The more concretely you describe the situation, the more concretely we can respond.
            </p>
          </header>
          <div className="contact-links">
            <a href="mailto:contact@silicoinformatics.com" className="contact-link">
              <span className="eyebrow">General</span>
              <span>contact@silicoinformatics.com</span>
            </a>
            <a href="mailto:sales@silicoinformatics.com" className="contact-link">
              <span className="eyebrow">Sales</span>
              <span>sales@silicoinformatics.com</span>
            </a>
            <a href="mailto:support@silicoinformatics.com" className="contact-link">
              <span className="eyebrow">Support</span>
              <span>support@silicoinformatics.com</span>
            </a>
          </div>
        </div>

        <div className="card" style={{ padding: "var(--space-8)" }}>
          {sent ? (
            <div className="form__success">
              Thanks — we received your message and will be in touch shortly.
            </div>
          ) : (
            <form className="form" onSubmit={onSubmit}>
              {error && <div className="form__alert">{error}</div>}
              <div className="field">
                <label htmlFor="name">Your name</label>
                <input id="name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
              </div>
              <div className="field">
                <label htmlFor="email">Email</label>
                <input id="email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
              </div>
              <div className="field">
                <label htmlFor="company">Company (optional)</label>
                <input id="company" value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} />
              </div>
              <div className="field">
                <label htmlFor="message">What can we help with?</label>
                <textarea id="message" required minLength={10} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} />
              </div>
              <button type="submit" className="btn btn--primary" disabled={submitting}>
                {submitting ? "Sending…" : "Send message"}
              </button>
            </form>
          )}
        </div>
      </div>

      <style>{`
        .contact-intro {
          display: flex;
          flex-direction: column;
          gap: var(--space-10);
        }
        .contact-links {
          display: flex;
          flex-direction: column;
          gap: var(--space-1);
        }
        .contact-link {
          display: flex;
          flex-direction: column;
          gap: var(--space-1);
          color: var(--text-primary);
          padding: var(--space-3) 0;
          border-bottom: 1px solid var(--border-subtle);
        }
        .contact-link .eyebrow { margin-bottom: 0; }
        .contact-link:hover { color: var(--accent); }
        @media (max-width: 800px) {
          .contact-grid { grid-template-columns: 1fr !important; gap: var(--space-8) !important; }
        }
      `}</style>
    </section>
  );
}
